module.exports = __webpack_public_path__ + "images/user-02.8342b4cb.jpg";